import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setLanguage } from 'redux-i18n';

import Select from '../../common/Select';
import DsSection from '../../ds/molecules/DsSection';
import Btn from '../../ds/atoms/btn';
import DsInputField from '../../ds/atoms/form/inputField';
import DsLabelError from '../../ds/atoms/label/labelError';
import withNavigate from '../../../withNavigate'; // Importa el HOC

import {
  BOOKING_STEP, getBookingDetail, setBookEmail, setBookLocator, setStep,
  setEditBooking,
} from '../../../actions/Booking';
import { CALL_CENTER_ROLE } from '../../../constants';

import '../../../static/less/my_booking.less';

class MyBooking extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      locator: '',
      type: 'email',
      loading: false,
      bookingNotFound: false,
      email: '',
      affiliate: '',
      surname: '',
    };

    this.onChangeAttr = this.onChangeAttr.bind(this);
    this.onSelectType = this.onSelectType.bind(this);
    this.onLoadBooking = this.onLoadBooking.bind(this);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    if (this.props.params.lang) {
      this.props.dispatch(setLanguage(this.props.params.lang));
    }
    this.props.dispatch(setStep(BOOKING_STEP.NO_AVAIL_STEP));
  }

  onSelectType(selectedType) {
    this.setState({ type: selectedType.value });
  }

  onChangeAttr = (name) => (e) => {
    this.setState({ [name]: e.target.value });
  };

  onChangeBookingReference = (e) => {
    this.setState({ locator: e.target.value.trim() });
  };

  isRbLocator(locator) {
    return /[a-z0-9]{10}/.test(locator);
  }

  onLoadBooking(e) {
    e.preventDefault();

    // Vamos a detectar si es un localizador de roiback. En tal caso debemos saltar ahí.
    if (this.isRbLocator(this.state.locator)) {
      const url = `http://reservas.${this.props.chain.toLowerCase()}.com/bookcore/your-booking/${this.state.locator}`;
      window.location = url;
    } else {
      this.setState({ loading: true, bookingNotFound: false });

      let value = this.state.email;
      if (this.state.type === 'affiliate') {
        value = this.state.affiliate;
      } else if (this.state.type === 'surname') {
        value = this.state.surname;
      }

      this.props.dispatch(getBookingDetail(
        this.props.lang,
        this.state.locator,
        this.state.type,
        value,
      )).then((r) => {
        if (r && r.booking) {
          this.setState({ loading: false, bookingNotFound: false });
          this.props.dispatch(setBookLocator(r.booking.locator));
          this.props.dispatch(setBookEmail(r.booking.cli_email));
          this.props.dispatch(setEditBooking(r.booking));
          this.props.navigate('/booking-detail/');
        } else {
          this.setState({ loading: false, bookingNotFound: true });
        }
      });
    }
  }

  renderTypeInput() {
    switch (this.state.type) {
      case 'email':
        return <DsInputField type="email" placeholder={this.context.t('Email')}
                             required minLength={3} maxLength={100} onChange={this.onChangeAttr('email')}
                             value={this.state.email}/>;
      case 'affiliate':
        return <DsInputField className="form-control" type="text"
                             placeholder={this.context.t('Affiliate number')} required
                             minLength={3} maxLength={25} value={this.state.affiliate}
                             onChange={this.onChangeAttr('affiliate')}/>;
      default:
        return null;
    }
  }

  renderLoginType() {
    const loginTypes = [
      { value: 'email', code: 'email', name: this.context.t('Email') },
      {
        value: 'affiliate',
        code: 'affiliate',
        name: this.context.t('{loyalty} customer code', {
          loyalty: this.props.chainData.booking_engine_configuration.loyalty_name,
        }),
      },
    ];
    const selectedItem = { code: this.state.type, value: this.state.type };
    return (
            <div className="mt-2">
              <Select selectId="type" options={loginTypes} lang={this.props.lang}
                      onSelect={this.onSelectType} selectedValue={selectedItem}/>
              {this.renderTypeInput()}
            </div>
    );
  }

  render() {
    const { isCallCenterUser } = this.props;
    const hasError = this.state.bookingNotFound;
    return (
            <DsSection title={this.context.t('Booking details')} className="text-base">
              <p>{this.context.t('Access only valid for reservations done at Sandos.com and Call Center')}.</p>
              <form className="mt-4" onSubmit={this.onLoadBooking}>
                <DsInputField type="text" value={this.state.locator}
                              onChange={this.onChangeBookingReference} required
                              minLength={6} maxLength={100} placeholder={this.context.t('Booking reference')}/>
                {!isCallCenterUser && this.renderLoginType()}
                {hasError && (
                        <DsLabelError>
                          {this.context.t('We could not find this booking')}
                        </DsLabelError>
                )}
                <div className="mt-4">
                  <Btn disabled={this.state.loading} variant="primary" type="button">
                    {this.state.loading ? this.context.t('One moment, please...')
                      : this.context.t('Continue')}
                  </Btn>
                </div>

              </form>
            </DsSection>
    );
  }
}

MyBooking.propTypes = {
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

MyBooking.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  lang: state.i18nState.lang,
  chain: state.bookingFormState.chain,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  chainData: state.session.chainData,
});

const ConnectedMyBooking = connect(mapStateToProps)(MyBooking);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedMyBooking);
